import { createSlice } from "@reduxjs/toolkit";

const groupSlice = createSlice({
  name: "group",
  initialState: {
    groupDetails: {},
  },
  reducers: {
    setGroupDetails(state, action) {
      state.groupDetails = action.payload;
    },
  },
});

export const { setGroupDetails } = groupSlice.actions;

export default groupSlice.reducer;
